<template>
  <div class="is-border task" :class="{'is-grey has-text-grey': isRemoved, 'has-bg-white': !isRemoved}">
    <div class="over"></div>
    <div class="columns">
      <div class="column is-narrow is-margin-top-xsmall is-padding-top-small is-padding-bottom-xsmall">
        <span class="avatar">
            <span class="has-bg-success has-text-white">
              <i class="fal fa-building fa-lg"></i>
            </span>
        </span>
      </div>
      <div class="column is-paddingless-left is-padding-top-small is-padding-bottom-xsmall">
        <p class="is-size-7 has-text-weight-light has-text-grey is-margin-bottom-xsmall">
          <span v-if="isToday">Aujourd’hui à {{date | dtFormat('HH[h]mm')}}</span>
          <span v-else>{{date | prettyDatetime}}</span>
        </p>
        <p class="is-size-4">
          <strong>Option — 
            <router-link :to="{name: 'LotVue', params: {id: option.lot}}">{{option.lot_ref}}</router-link>
          </strong>&nbsp;{{option.program_name}}
        </p>
        <div class="columns is-gapless is-multiline">
          <div class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right-xlarge is-size-6">
            <router-link :to="{name: 'UserVue', params: {id: option.seller}}">
              <span class="has-text-grey">Vendeur :</span><br><span class="is-hover-underline">{{option.seller_name}}</span>
            </router-link>
          </div>
          <div v-if="option.company"
               class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right-xlarge is-size-6">
            <router-link :to="{name: 'CompanyVue', params: {id: option.company}}">
              <span class="has-text-grey">Société :</span><br><span class="is-hover-underline">{{option.company_name}}</span>
            </router-link>
          </div>
          <div class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right-xlarge is-size-6">
            <router-link :to="{name: 'ContactVue', params: {id: option.buyer}}">
              <span class="has-text-grey">Contact :</span><br><span class="is-hover-underline">{{option.buyer_name}}</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"
                mode="out-in">
      <div v-if="isPending" key="buttons"
           class="column veryFastAnimation is-paddingless-top is-paddingless-bottom is-border-top is-border-dashed task-footer">
        <button @click="approveOption" class="button is-white is-size-7 is-height-4 is-min-width-0"
        :disabled="cardLoading">
          <span class="icon is-small"><i class="fas fa-check"></i></span>
          <span>Accepter</span>
        </button>
        <button @click="refuseOption" class="button is-white is-size-7 is-height-4 is-min-width-0"
        :disabled="cardLoading">
          <span class="icon is-small"><i class="fas fa-do-not-enter"></i></span>
          <span>Décliner</span>
        </button>
      </div>
      <div v-else-if="isRemoved" key="noButtons"
           class="column veryFastAnimation is-padding-top-small is-padding-bottom-small is-border-top task-footer has-bg-light-darken-1 is-border-top is-border-dashed has-text-grey is-size-6">
        <div class="is-min-width-0">
          Option <span v-if="isRunning">acceptée</span><span v-else>refusée</span>
          le {{option.updated_on | prettyDatetime}}
          <span v-if="option.update_author === currentUserPk">
          par vous.
        </span>
          <span v-else-if="option.update_author_name">
          par {{option.update_author_name}}
        </span>
        </div>
      </div>
    </transition>
  </div>

</template>

<script>
  import moment from 'moment'
  import { mapGetters } from 'vuex'

  export default {
    name: 'OptionCard',
    props: {
      option: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapGetters(['currentUserPk']),
      isRemoved () {
        return !this.isPending && this.option.updated_on
      },
      date () {
        return moment(this.option.start_date)
      },
      isToday () {
        return this.date.isSame(moment(), 'day')
      },
      isPending () {
        return this.status === 'pending'
      },
      isRunning () {
        return this.status === 'waiting_list' || this.status === 'approved'
      },
      isCanceled () {
        return this.status === 'canceled_by_admin' || this.status === 'canceled_by_seller'
      },
      optionPk () {
        return this.option.pk
      },
      status () {
        return this.option.status
      }
    },
    data () {
      return {
        cardLoading: false
      }
    },
    methods: {
      approveOption () {
        this.cardLoading = true
        this.$api.optionService.patch(this.optionPk, {status: 'approved'}).then(r => {
          this.$notify({
            type: 'is-success',
            text: 'Option acceptée'
          })
        })
      },
      refuseOption () {
        this.cardLoading = true
        this.$api.optionService.patch(this.optionPk, {status: 'refused'}).then(r => {
          this.$notify({
            type: 'is-success',
            text: 'Option refusée'
          })
        })
      },
      editOption () {
        this.cardLoading = true
        this.$store.commit('setQuickview', {mode: 'OPTION_EDIT'})
      }
    },
    created () {
      this.$emit('process', this.option)
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/home/dashboard-admin/event-card/OptionCard.vue